
export default {
    async inserted(el, bindings, vnode) {
        const tabs = vnode.componentInstance;

        await tabs.$nextTick();

        function init() {
            const tab = tabs.tabs.find(tab =>
                tab.titleLinkAttributes?.href === (location.hash || '#')
            );
            tab?.activate();
        }

        function handleTabClicked(tab) {
            const href = tab.titleLinkAttributes?.href;
            if(href) {
                history.pushState(null, null, href);
            }
        }

        tabs.tabs.forEach(tab => {
            tab.$on('click', () => handleTabClicked(tab));
        })

        window.addEventListener('popstate', el._anchorTabUpdate = init);

        init();
    },
    unbind(el) {
        window.addEventListener('popstate', el._anchorTabUpdate);
    },
}
